/**************************************************
 * Nombre:       Detalle_Relacionados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Tarjeta_Producto_Home from "../../Tarjetas/Tarjeta_Producto_Home";

const Detalle_Relacionados = () => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                            <Typography sx={{fontSize: 20, fontWeight: 700}}>TAMBIEN TE PODRIA INTERESAR</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={4}
                        >

                            {items.map((item, i) => (
                                <Grid container size={{xs: 6, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Producto_Home/>
                                </Grid>
                            ))}

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Detalle_Relacionados

const items = [1, 2, 3, 4]